import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const STRUCTURELENS_FAQ = [
  {
    q: "What is AI chart analysis for gold?",
    a: "AI chart analysis interprets a price chart and returns a structured reading: bias, structure, liquidity, points of interest, and risk. StructureLens performs this analysis specifically for XAUUSD through the XAU Pro Academy SMC doctrine, returning the same fixed schema on every reading.",
  },
  {
    q: "How is StructureLens different from a generic AI chart analyzer?",
    a: "Generic tools optimize for an answer on any chart. StructureLens applies hard rejection rules from a fixed SMC doctrine, returns a comparable institutional schema every time, specializes in gold, and shares the same reasoning framework audited in the Validation Hub.",
  },
  {
    q: "Does StructureLens use Smart Money Concepts?",
    a: "Yes. The reasoning is built on institutional SMC: market structure (BOS, CHoCH, MSS), liquidity (BSL, SSL, IDM), displacement, point-of-interest qualification (Order Blocks, Fair Value Gaps, Breakers), and session context. Each concept is documented in the XAU Pro Academy Knowledge Base.",
  },
  {
    q: "Which timeframes does it analyze?",
    a: "StructureLens reads any timeframe you upload. The doctrine prioritizes a multi-timeframe hierarchy: H4 for directional bias, H1 for structural confirmation, and M15 for execution. Counter-trend readings are flagged and require additional confirmation.",
  },
  {
    q: "Is StructureLens a signal service?",
    a: "No. StructureLens analyzes charts you upload and returns a structured reading. It does not publish signals or scan the market on its own. Orion is the separate decision engine that publishes signals when doctrine is satisfied.",
  },
  {
    q: "Is there a free plan?",
    a: "Yes. A free account includes one StructureLens analysis per week with no card required, no trial timer, and no expiration. Membership lifts the weekly limit and unlocks the rest of the Platform.",
  },
  {
    q: "Can StructureLens analyze TradingView screenshots?",
    a: "Yes. StructureLens accepts any clean chart image, including TradingView screenshots, in PNG, JPG, or WEBP. For best results, capture the chart on a timeframe you actually trade (H4, H1, or M15 for XAUUSD) with visible structure and liquidity zones. Indicators are optional. The reading is driven by price action under SMC doctrine.",
  },
];

export function FaqSection() {
  return (
    <section className="border-b border-border/60 bg-background">
      <div className="container mx-auto max-w-4xl px-4 py-16 lg:py-20">
        <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-muted-foreground">
          Frequently asked
        </div>
        <h2 className="mt-2 font-display text-2xl font-semibold tracking-tight text-foreground lg:text-3xl">
          AI chart analysis for gold, answered.
        </h2>

        <Accordion type="single" collapsible className="mt-8">
          {STRUCTURELENS_FAQ.map((item, i) => (
            <AccordionItem key={i} value={`q-${i}`}>
              <AccordionTrigger className="text-left font-display text-base font-semibold">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
